import React from 'react';
import { IButtonProps, PrimaryButton, DefaultButton } from '@fluentui/react';

export enum BwjButtonType {
    PrimaryStandard,
    DefaultStandard,
}

export interface IBwjButtonProps extends IButtonProps {
    buttonStyle: BwjButtonType;
    text?: string;
}

export const BwjButton: React.FunctionComponent<IBwjButtonProps> = (props) => {

  return (
    props.buttonStyle === BwjButtonType.PrimaryStandard ?
    <PrimaryButton {...props}>{props.children ?? props.text ?? ''}</PrimaryButton>
    :
    <DefaultButton {...props}>{props.children ?? props.text ?? ''}</DefaultButton>
  );
};
